import React from 'react'
import { CentricTypography } from '@core/component/CentricTypography'
import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles(theme => ({
  qtyCellWrapper: {
    height: 30,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderBottom: '1px solid #ccc',
    borderLeft: '1px solid #ccc',
    marginLeft: -1
  }
}))

const IAWarehouseKPICell = ({ value = '--' }) => {
  const classes = useStyles()
  return (
    <div className={classes.qtyCellWrapper}>
      <CentricTypography variant={'subtitle1'}>{value}</CentricTypography>
    </div>
  )
}

export default IAWarehouseKPICell
